import type { Ticket } from '@centraoneplus/shared-types';

/**
 * The small label a ticket row shows about its secondary agents:
 *  - "Secondary" when the viewer works the ticket as a secondary agent
 *    (it is in their list because of that, not because they own it);
 *  - "+N" for N secondary agents otherwise;
 *  - null when the ticket has none.
 */
export function secondaryBadgeLabel(
  ticket: Pick<Ticket, 'secondaryAssignees'>,
  currentUserId: string | undefined,
): string | null {
  const ids = (ticket.secondaryAssignees ?? []).map((s) => s.userId);
  if (ids.length === 0) return null;
  if (currentUserId && ids.includes(currentUserId)) return 'Secondary';
  return `+${ids.length}`;
}
